export const producttable = {
    init: () => {
        const certificateLinks = document.querySelectorAll('.producttable__certificate a')

        certificateLinks.forEach(link => {
            link.addEventListener('click', () => {
                openPopup(link.getAttribute('href'))
            })
        })
    }
}

let toastArea = null;
const openPopup = (href) => {
    if (!toastArea) {
        toastArea = document.createElement('div');
        toastArea.classList.add('sal-toast__area');
        document.body.appendChild(toastArea);
    }

    const sourceElement = document.querySelector(href)

    if (sourceElement) {
        const sourceHtml = sourceElement.innerHTML;

        const div = document.createElement('div');
        const content = document.createElement('div');
        content.classList.add('background');
        div.classList.add('sal-toast', 'sal-toast--message');

        content.innerHTML += `
            <span class='sal-toast__icon button button--secondary button--icon icon--before icon--close' aria-label='close'></span>
        `;

        content.innerHTML += sourceHtml

        div.appendChild(content);

        toastArea.innerHTML = '';
        toastArea.appendChild(div);
        setTimeout(() => {
            div.classList.add('show');
        }, 100);

        div.querySelector('.icon--close').addEventListener('click', () => {
            div.classList.add('hide');
            div.addEventListener('transitionend', () => {
                toastArea.removeChild(div);
            });
        });
    }
}
